<template>


    <div class="page-content">   
		<div data-height="150" class="page-title-bg bg-20"><!-- image --></div>
		<div data-height="150" class="page-title-bg dark-mode-tint"><!-- contrast for dark mode --></div>
		<div data-height="150" class="page-title-bg opacity-90 bg-highlight"><!-- background color --></div>
		
		<div class="page-title-small color-white bottom-30">
			<h1><i class="fa fa-arrow-left back-button"></i>{{ tituloedicion }}</h1>
			<a href="/dashboard" data-menu="menu-main" class="shadow-huge scale-box bg-fade-gray2-dark" v-bind:style="userimageurl"></a>
		</div>
	
     
		<div class="content-boxed">

  			<div class="content bottom-0">
				
               <div class="contact-form">
                    <form onsubmit="event.preventDefault();" class="contactForm" id="Formsubmit">

								<span id="placaverificada" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">La Placa patente se encuentra en otro vehículo</span>

								<span id="r_field_ST_PLACAPATENTE_VEHICULO" name="r_field_ST_PLACAPATENTE_VEHICULO" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Placa patente requerido</span>
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">Placa patente:<span>(requerida)</span></label>
									<input id="field_ST_PLACAPATENTE_VEHICULO" name="field_ST_PLACAPATENTE_VEHICULO" type="text" maxlength="6"
									v-model="TABLE.ST_PLACAPATENTE_VEHICULO" 
									class="round-small" @change="Verificarpatente()">
								</div>



								<input id="field_IN_VALORNIVEL1_VEHICULO" name="field_IN_VALORNIVEL1_VEHICULO" type="hidden" v-model="TABLE.IN_VALORNIVEL1_VEHICULO">
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">Marca:<span>(requerida)</span></label>
								</div>
								<span id="r_field_IN_VALORNIVEL1_VEHICULO" name="r_field_IN_VALORNIVEL1_VEHICULO" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Marca requerida</span>
								<div class="input-style input-style-2 bg-green3-light round-tiny">
									<span id='spanMARCA' class="bg-green3-light"><font style="color:#ffffff">{{ TABLE.MARCA }}</font></span>
									<em><i class="fa fa-angle-down"></i></em>
									<select id="select_IN_VALORNIVEL1_VEHICULO" ref="select_IN_VALORNIVEL1_VEHICULO" @change="selmarca()">
										<option class="bg-green3-light" disabled selected>Seleccionar marca</option>
										<option v-for="lst in marcalist"  class="bg-green3-light"  v-bind:value="lst.IN_COD_DETALLECLASIFICACION">{{ lst.ST_DESC_DETALLECLASIFICACION.toUpperCase() }}</option>
									</select>
								</div>

								<input id="field_IN_VALORNIVEL2_VEHICULO" name="field_IN_VALORNIVEL2_VEHICULO" type="hidden" v-model="TABLE.IN_VALORNIVEL2_VEHICULO">
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">Modelo:<span>(requerido)</span></label>
								</div>
								<span id="r_field_IN_VALORNIVEL2_VEHICULO" name="r_field_IN_VALORNIVEL2_VEHICULO" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Modelo requerido</span>
								<div class="input-style input-style-2 bg-green2-light round-tiny">
									<span id='spanMODELO' class="bg-green2-light"><font style="color:#ffffff">{{ TABLE.MODELO }}</font></span>
									<em><i class="fa fa-angle-down"></i></em>
									<select id="select_IN_VALORNIVEL2_VEHICULO" ref="select_IN_VALORNIVEL2_VEHICULO" @change="selmodelo()">
										<option class="bg-green2-light" disabled selected>Seleccionar modelo</option>
										<option v-for="lst in modelolist" class="bg-green2-light" v-bind:value="lst.IN_COD_DETALLECLASIFICACION">{{ lst.ST_DESC_DETALLECLASIFICACION.toUpperCase() }}</option>
									</select>
								</div>

								<input id="field_IN_VALORNIVEL3_VEHICULO" name="field_IN_VALORNIVEL3_VEHICULO" type="hidden" v-model="TABLE.IN_VALORNIVEL3_VEHICULO">
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">Versión:<span>(requerida)</span></label>
								</div>
								<span id="r_field_IN_VALORNIVEL3_VEHICULO" name="r_field_IN_VALORNIVEL3_VEHICULO" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Versión requerida</span>
								<div class="input-style input-style-2 bg-green1-light round-tiny">
									<span id='spanVERSION' class="bg-green1-light"><font style="color:#ffffff">{{ TABLE.VERSION }}</font></span>
									<em><i class="fa fa-angle-down"></i></em>
									<select id="select_IN_VALORNIVEL3_VEHICULO" ref="select_IN_VALORNIVEL3_VEHICULO" @change="selversion()">
										<option class="bg-green1-light" disabled selected>Seleccionar versión</option>
										<option v-for="lst in versionlist" class="bg-green1-light" v-bind:value="lst.IN_COD_DETALLECLASIFICACION">{{ lst.ST_DESC_DETALLECLASIFICACION.toUpperCase() }}</option>
									</select>
								</div>


								<span id="r_field_IN_AGNOFABRICACION_VEHICULO" name="r_field_IN_AGNOFABRICACION_VEHICULO" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Año requerido</span>
								<span id="i_field_IN_AGNOFABRICACION_VEHICULO" name="i_field_IN_AGNOFABRICACION_VEHICULO" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Año debe ser un número</span>
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">Año:<span>(requerido)</span></label>
									<input id="field_IN_AGNOFABRICACION_VEHICULO" name="field_IN_AGNOFABRICACION_VEHICULO" type="number" maxlength="4"
									v-model="TABLE.IN_AGNOFABRICACION_VEHICULO" 
									class="round-small">
								</div>

						
<br/>
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme" >Fecha primera compra: <b style="font-size:1.2em">{{ TABLE.FECHAPRIMERACOMPRA }}</b><span></span></label>
								</div>
								<br/>


								<input id="field_IN_COD_TIPOVEHICULO" name="field_IN_COD_TIPOVEHICULO" type="hidden" v-model="TABLE.IN_COD_TIPOVEHICULO">
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">Tipo vehículo:<span>(requerido)</span></label>
								</div>
								<span id="r_field_IN_COD_TIPOVEHICULO" name="r_field_IN_COD_TIPOVEHICULO" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Tipo vehículo requerido</span>
								<div class="input-style input-style-2">
									<span>{{ TABLE.TIPOVEHICULO }}</span>
									<em><i class="fa fa-angle-down"></i></em>
									<select id="select_IN_COD_TIPOVEHICULO" ref="select_IN_COD_TIPOVEHICULO" @change="seltipovehiculo()">
										<option v-for="lst in tipovehiculolist" v-bind:value="lst.IN_COD_TIPOVEHICULO">{{ lst.ST_DESC_TIPOVEHICULO.toUpperCase() }}</option>
									</select>
								</div>


								<input id="field_IN_COD_DISEGNO" name="field_IN_COD_DISEGNO" type="hidden" v-model="TABLE.IN_COD_DISEGNO">
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">Diseño:<span>(requerido)</span></label>
								</div>
								<span id="r_field_IN_COD_DISEGNO" name="r_field_IN_COD_DISEGNO" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Diseño requerido</span>
								<div class="input-style input-style-2">
									<span>{{ TABLE.DISEGNO }}</span>
									<em><i class="fa fa-angle-down"></i></em>
									<select id="select_IN_COD_DISEGNO" ref="select_IN_COD_DISEGNO" @change="seldisegno()">
										<option v-for="lst in disegnolist" v-bind:value="lst.IN_COD_DISEGNO">{{ lst.ST_DESC_DISEGNO.toUpperCase() }}</option>
									</select>
								</div>


								<input id="field_IN_COD_CILINDRADA" name="field_IN_COD_CILINDRADA" type="hidden" v-model="TABLE.IN_COD_CILINDRADA">
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">Cilindrada:<span>(requerida)</span></label>
								</div>
								<span id="r_field_IN_COD_CILINDRADA" name="r_field_IN_COD_CILINDRADA" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Cilindrada requerido</span>
								<div class="input-style input-style-2">
									<span>{{ TABLE.CILINDRADA }}</span>
									<em><i class="fa fa-angle-down"></i></em>
									<select id="select_IN_COD_CILINDRADA" ref="select_IN_COD_CILINDRADA" @change="selcilindrada()">
										<option v-for="lst in cilindradalist" v-bind:value="lst.IN_COD_CILINDRADA">{{ lst.ST_DESC_CILINDRADA.toUpperCase() }}</option>
									</select>
								</div>


								<input id="field_IN_COD_TRANSMISION" name="field_IN_COD_TRANSMISION" type="hidden" v-model="TABLE.IN_COD_TRANSMISION">
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">Transmisión:<span>(requerida)</span></label>
								</div>
								<span id="r_field_IN_COD_TRANSMISION" name="r_field_IN_COD_TRANSMISION" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Transmisión requerido</span>
								<div class="input-style input-style-2">
									<span>{{ TABLE.TRANSMISION }}</span>
									<em><i class="fa fa-angle-down"></i></em>
									<select id="select_IN_COD_TRANSMISION" ref="select_IN_COD_TRANSMISION" @change="seltransmision()">
										<option v-for="lst in transmisionlist" v-bind:value="lst.IN_COD_TRANSMISION">{{ lst.ST_DESC_TRANSMISION.toUpperCase() }}</option>
									</select>
								</div>


								<input id="field_IN_COD_TIPOTRACCION" name="field_IN_COD_TIPOTRACCION" type="hidden" v-model="TABLE.IN_COD_TIPOTRACCION">
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">Tipo tracción:<span>(requerido)</span></label>
								</div>
								<span id="r_field_IN_COD_TIPOTRACCION" name="r_field_IN_COD_TIPOTRACCION" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Tipo tracción requerido</span>
								<div class="input-style input-style-2">
									<span>{{ TABLE.TIPOTRACCION }}</span>
									<em><i class="fa fa-angle-down"></i></em>
									<select id="select_IN_COD_TIPOTRACCION" ref="select_IN_COD_TIPOTRACCION" @change="seltipotraccion()">
										<option v-for="lst in tipotraccionlist" v-bind:value="lst.IN_COD_TIPOTRACCION">{{ lst.ST_DESC_TIPOTRACCION.toUpperCase() }}</option>
									</select>
								</div>


								<input id="field_IN_COD_TIPOCOMBUSTIBLE" name="field_IN_COD_TIPOCOMBUSTIBLE" type="hidden" v-model="TABLE.IN_COD_TIPOCOMBUSTIBLE">
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">Tipo combustible:<span>(requerido)</span></label>
								</div>
								<span id="r_field_IN_COD_TIPOCOMBUSTIBLE" name="r_field_IN_COD_TIPOCOMBUSTIBLE" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Tipo combustible requerido</span>
								<div class="input-style input-style-2">
									<span>{{ TABLE.TIPOCOMBUSTIBLE }}</span>
									<em><i class="fa fa-angle-down"></i></em>
									<select id="select_IN_COD_TIPOCOMBUSTIBLE" ref="select_IN_COD_TIPOCOMBUSTIBLE" @change="seltipocombustible()">
										<option v-for="lst in tipocombustiblelist" v-bind:value="lst.IN_COD_TIPOCOMBUSTIBLE">{{ lst.ST_DESC_TIPOCOMBUSTIBLE.toUpperCase() }}</option>
									</select>
								</div>

								<input id="field_IN_COD_COLOR" name="field_IN_COD_COLOR" type="hidden" v-model="TABLE.IN_COD_COLOR">
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">Color:<span>(requerido)</span></label>
								</div>
								<span id="r_field_IN_COD_COLOR" name="r_field_IN_COD_COLOR" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Color requerido</span>
								<div class="input-style input-style-2">
									<span>{{ TABLE.COLOR }}</span>
									<em><i class="fa fa-angle-down"></i></em>
									<select id="select_IN_COD_COLOR" ref="select_IN_COD_COLOR" @change="selcolor()">
										<option v-for="lst in colorlist" v-bind:value="lst.IN_COD_COLOR">{{ lst.ST_DESC_COLOR.toUpperCase() }}</option>
									</select>
								</div>

								<span id="r_field_IN_KILOMETRAJE_VEHICULO" name="r_field_IN_KILOMETRAJE_VEHICULO" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Kilometraje requerido</span>
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">Kilometraje:<span>(requerida)</span></label>
									<input id="field_IN_KILOMETRAJE_VEHICULO" name="field_IN_KILOMETRAJE_VEHICULO" type="number" maxlength="6"
									v-model="TABLE.IN_KILOMETRAJE_VEHICULO" 
									class="round-small">
								</div>
								<span id="r_field_ST_NVIN_VEHICULO" name="r_field_ST_NVIN_VEHICULO" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">VIN requerido</span>
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">VIN:<span>(requerido)</span></label>
									<input id="field_ST_NVIN_VEHICULO" name="field_ST_NVIN_VEHICULO" type="text" maxlength="20"
									v-model="TABLE.ST_NVIN_VEHICULO" 
									class="round-small">
								</div>
								<span id="r_field_ST_NMOTOR_VEHICULO" name="r_field_ST_NMOTOR_VEHICULO" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Motor requerido</span>
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">N°Motor:<span>(requerido)</span></label>
									<input id="field_ST_NMOTOR_VEHICULO" name="field_ST_NMOTOR_VEHICULO" type="text" maxlength="20"
									v-model="TABLE.ST_NMOTOR_VEHICULO" 
									class="round-small">
								</div>



					<div > 

						<div class="content-boxed">
								<a v-if="!isedit" href="#" class="button bg-blue1-dark button-m button-full round-small bottom-10 shadow-small contactSubmitButton" @click="GoAction('insertar');" data-formId="dataForm">Ingresar vehículo</a>
								<a v-if="isedit" href="#" class="button bg-blue1-dark button-m button-full round-small bottom-10 shadow-small contactSubmitButton" @click="GoAction('actualizar');" data-formId="dataForm">Actualizar vehículo</a>
						</div>
					</div>

                    </form>			
                </div>
            </div>


    	</div>
		
    </div>


</template>

<script>

import * as db from "../../database.js";
import * as validate from "../../validate.js";

export default {
	data() {
      return {
		TABLE:{},
		codvehiculo:0,
		tituloedicion:"Editar vehículo",
		isedit:true,

		verificarplacapatente:[],
		
		marcalist:[],
		modelolist:[],
		versionlist:[],

		disegnolist:[],
		cilindradalist:[],
		transmisionlist:[],
		tipotraccionlist:[],
		tipocombustiblelist:[],
		colorlist:[],

		}
	},
/*

                            & "_VEHICULO;type=class;classtype=" & CAR_CARACTERISTICACLASIFICACION.MODELOCLASIFICACION & ";descwidth=150;cols=2," _
                            & ";desc=Tipo vehículo;type=custom," _
                            & "IN_COD_DISEGNO;desc=Diseño;type=custom," _
                            & "IN_COD_CILINDRADA;desc=Cilindrada;type=custom," _
                            & "IN_COD_TRANSMISION;desc=Transmisión;type=custom," _
                            & "IN_COD_TIPOTRACCION;desc=Tipo tracción;type=custom," _
                            & "IN_COD_TIPOCOMBUSTIBLE;desc=Combustible;type=custom," _
                            & "IN_COD_COLOR;desc=Color;type=custom," _
                            & "ST_NMOTOR_VEHICULO;desc=Nº motor;maxlength=30;size=30;uppercase=true," _
                            & "ST_NVIN_VEHICULO;desc=Nº VIN;maxlength=30;size=30;uppercase=true;required=true," _
                            & "IN_KILOMETRAJE_VEHICULO;desc=Kilometraje;type=numeric;size=8;maxlength=8;format=n;required=true," _
                            & "IN_ESNUEVO_VEHICULO;hidden=true;value=0," _
                            & "IN_ESTADO_VEHICULO;hidden=true;value=" & CAR_VEHICULOESTADO.TOMA
*/
	mounted() {
		let strSql;

		if(localStorage.getItem('editcodvehiculo')!="")
			{
			this.codvehiculo=localStorage.getItem('editcodvehiculo');
			this.isedit=true;
			localStorage.setItem('searchplacapatente',"");
			//localStorage.setItem('editcodvehiculo',"");

			this.tituloedicion="Editar vehículo ficha N° "+this.codvehiculo;

			strSql="SELECT V.*,CONVERT(varchar(11),DT_FECHAPRIMERACOMPRA_VEHICULO,103) FECHAPRIMERACOMPRA,"
				+"(SELECT ST_DESC_TIPOVEHICULO T FROM T_VEH_TIPOVEHICULO T WHERE T.IN_COD_TIPOVEHICULO=V.IN_COD_TIPOVEHICULO) TIPOVEHICULO,"
				+"(SELECT ST_DESC_DISEGNO T FROM T_VEH_DISEGNO T WHERE T.IN_COD_DISEGNO=V.IN_COD_DISEGNO) DISEGNO,"
				+"(SELECT ST_DESC_CILINDRADA T FROM T_VEH_CILINDRADA T WHERE T.IN_COD_CILINDRADA=V.IN_COD_CILINDRADA) CILINDRADA,"
				+"(SELECT ST_DESC_TRANSMISION T FROM T_VEH_TRANSMISION T WHERE T.IN_COD_TRANSMISION=V.IN_COD_TRANSMISION) TRANSMISION,"
				+"(SELECT ST_DESC_TIPOTRACCION T FROM T_VEH_TIPOTRACCION T WHERE T.IN_COD_TIPOTRACCION=V.IN_COD_TIPOTRACCION) TIPOTRACCION,"
				+"(SELECT ST_DESC_TIPOCOMBUSTIBLE T FROM T_VEH_TIPOCOMBUSTIBLE T WHERE T.IN_COD_TIPOCOMBUSTIBLE=V.IN_COD_TIPOCOMBUSTIBLE) TIPOCOMBUSTIBLE,"
				+"(SELECT ST_DESC_COLOR T FROM T_VEH_COLOR T WHERE T.IN_COD_COLOR=V.IN_COD_COLOR) COLOR,"
				+"(SELECT ST_DESC_DETALLECLASIFICACION D FROM T_GEN_DETALLECLASIFICACION D WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL1_VEHICULO) MARCA,"
				+"(SELECT ST_DESC_DETALLECLASIFICACION D FROM T_GEN_DETALLECLASIFICACION D WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL2_VEHICULO) MODELO,"
				+"(SELECT ST_DESC_DETALLECLASIFICACION D FROM T_GEN_DETALLECLASIFICACION D WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL3_VEHICULO) VERSION"
				+" FROM T_VEH_VEHICULO V"
				+" WHERE IN_COD_VEHICULO="+this.codvehiculo

			db.getQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
				this.TABLE=result.data.data
			}}); 


			}
		else
			{
			this.isedit=false;

			strSql =  " INSERT INTO T_VEH_VEHICULO(IN_ESNUEVO_VEHICULO,IN_ESTADO_VEHICULO) VALUES(0,0)" 
					+ " SELECT MAX(IN_COD_VEHICULO) codvehiculo FROM T_VEH_VEHICULO" 
			db.getQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
				this.insertarvehiculo=result.data.data
				this.codvehiculo=this.insertarvehiculo.codvehiculo;
				this.tituloedicion="Nuevo vehículo";
			}}); 

			localStorage.setItem('searchplacapatente',"");
			}


		strSql =  " SELECT N1.IN_COD_DETALLECLASIFICACION," 
				+ " N1.ST_DESC_DETALLECLASIFICACION" 
				+ " FROM T_GEN_DETALLECLASIFICACION N1"
				+ " WHERE IN_COD_CLASIFICACION=1"
				+ " AND IN_VALORNIVEL1_DETALLECLASIFICACION=IN_COD_DETALLECLASIFICACION"
		this.marcalist=[];
		db.getQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
			this.marcalist=result.data.data
		}}); 

		strSql="SELECT * FROM T_VEH_TIPOVEHICULO ORDER BY ST_DESC_TIPOVEHICULO"
		this.tipovehiculolist=[];
		db.getQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
			this.tipovehiculolist=result.data.data
		}}); 

		strSql="SELECT * FROM T_VEH_DISEGNO ORDER BY ST_DESC_DISEGNO"
		this.disegnolist=[];
		db.getQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
			this.disegnolist=result.data.data
		}}); 

		strSql="SELECT * FROM T_VEH_CILINDRADA ORDER BY ST_DESC_CILINDRADA"
		this.cilindradalist=[];
		db.getQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
			this.cilindradalist=result.data.data
		}}); 

		strSql="SELECT * FROM T_VEH_TRANSMISION ORDER BY ST_DESC_TRANSMISION"
		this.transmisionlist=[];
		db.getQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
			this.transmisionlist=result.data.data
		}}); 

		strSql="SELECT * FROM T_VEH_TIPOTRACCION ORDER BY ST_DESC_TIPOTRACCION"
		this.tipotraccionlist=[];
		db.getQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
			this.tipotraccionlist=result.data.data
		}}); 

		strSql="SELECT * FROM T_VEH_TIPOCOMBUSTIBLE ORDER BY ST_DESC_TIPOCOMBUSTIBLE"
		this.tipocombustiblelist=[];
		db.getQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
			this.tipocombustiblelist=result.data.data
		}}); 

		strSql="SELECT * FROM T_VEH_COLOR ORDER BY ST_DESC_COLOR"
		this.colorlist=[];
		db.getQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
			this.colorlist=result.data.data
		}}); 

		},

	methods: {
		GoAction(action)
			{
			var strErr=validate.check(Formsubmit)
				if (strErr==""){
						this.params='{"valkey":"'+this.codvehiculo+'","tablename":"T_VEH_VEHICULO"}';
						db.sendDataForm(Formsubmit,this.params)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
						if(action=="actualizar")
							{
							localStorage.setItem('searchplacapatente',"");
							window.location="/Wizardot1show";
							}
						else if(action=="insertar")
							{
							localStorage.setItem('searchplacapatente',this.TABLE.ST_PLACAPATENTE_VEHICULO);
							window.location="/NewOT";
							}
					}});
				}
			},


		//-------------------------------------------------------------------------------------------------------------------------------	
		selmarca(){
			var ref=this.$refs.select_IN_VALORNIVEL1_VEHICULO;this.TABLE.IN_VALORNIVEL1_VEHICULO=ref.value;this.TABLE.MARCA=ref.options[ref.selectedIndex].innerHTML;document.getElementById('r_field_IN_VALORNIVEL1_VEHICULO').style.display="none";this.$forceUpdate();

			this.TABLE.IN_VALORNIVEL2_VEHICULO="";
			this.TABLE.MODELO="";
			this.TABLE.IN_VALORNIVEL3_VEHICULO="";
			this.TABLE.VERSION="";

			this.$forceUpdate();
			
			this.cargarmodelos(this.$refs.select_IN_VALORNIVEL1_VEHICULO.value);
			},
		selmodelo(){
			var ref=this.$refs.select_IN_VALORNIVEL2_VEHICULO;this.TABLE.IN_VALORNIVEL2_VEHICULO=ref.value;this.TABLE.MODELO=ref.options[ref.selectedIndex].innerHTML;document.getElementById('r_field_IN_VALORNIVEL2_VEHICULO').style.display="none";this.$forceUpdate();

			this.TABLE.IN_VALORNIVEL3_VEHICULO="";
			this.TABLE.VERSION="";
			this.$forceUpdate();
			
			this.cargarversiones(this.$refs.select_IN_VALORNIVEL2_VEHICULO.value);
			},

		selversion(){var ref=this.$refs.select_IN_VALORNIVEL3_VEHICULO;this.TABLE.IN_VALORNIVEL3_VEHICULO=ref.value;this.TABLE.VERSION=ref.options[ref.selectedIndex].innerHTML;document.getElementById('r_field_IN_VALORNIVEL3_VEHICULO').style.display="none";this.$forceUpdate();},

		cargarmodelos(id)
			{
			let strSql;
			strSql =  " SELECT N2.IN_COD_DETALLECLASIFICACION," 
					+ " N2.ST_DESC_DETALLECLASIFICACION" 
					+ " FROM T_GEN_DETALLECLASIFICACION N2"
					+ " WHERE IN_COD_CLASIFICACION=1"
					+ " AND IN_VALORNIVEL1_DETALLECLASIFICACION="+id
					+ " AND IN_VALORNIVEL2_DETALLECLASIFICACION=IN_COD_DETALLECLASIFICACION"

			this.modelolist=[];
			db.getQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
					this.modelolist=result.data.data
					//alert(this.modelolist(0).IN_COD_DETALLECLASIFICACION);
				}}); 

			},

		cargarversiones(id)
			{
			let strSql;
		
			strSql =  " SELECT N3.IN_COD_DETALLECLASIFICACION," 
					+ " N3.ST_DESC_DETALLECLASIFICACION" 
					+ " FROM T_GEN_DETALLECLASIFICACION N3"
					+ " WHERE IN_COD_CLASIFICACION=1"
					+ " AND IN_VALORNIVEL2_DETALLECLASIFICACION="+id
					+ " AND IN_VALORNIVEL3_DETALLECLASIFICACION>0"
					+ " UNION" 
					+ " SELECT ''," 
					+ " '-'" 
					+ " FROM T_GEN_DETALLECLASIFICACION N3"
					+ " WHERE IN_COD_CLASIFICACION=1"
					+ " AND IN_VALORNIVEL2_DETALLECLASIFICACION="+id
					+ " AND IN_VALORNIVEL2_DETALLECLASIFICACION=IN_COD_DETALLECLASIFICACION"

			this.versionlist=[];
			db.getQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
					this.versionlist=result.data.data
				}}); 

			},


		//-------------------------------------------------------------------------------------------------------------------------------	
		seltipovehiculo(){var ref=this.$refs.select_IN_COD_TIPOVEHICULO;this.TABLE.IN_COD_TIPOVEHICULO=ref.value;this.TABLE.TIPOVEHICULO=ref.options[ref.selectedIndex].innerHTML;document.getElementById('r_field_IN_COD_TIPOVEHICULO').style.display="none";this.$forceUpdate();},

		seldisegno(){var ref=this.$refs.select_IN_COD_DISEGNO;this.TABLE.IN_COD_DISEGNO=ref.value;this.TABLE.DISEGNO=ref.options[ref.selectedIndex].innerHTML;document.getElementById('r_field_IN_COD_DISEGNO').style.display="none";this.$forceUpdate();},

		selcilindrada(){var ref=this.$refs.select_IN_COD_CILINDRADA;this.TABLE.IN_COD_CILINDRADA=ref.value;this.TABLE.CILINDRADA=ref.options[ref.selectedIndex].innerHTML;document.getElementById('r_field_IN_COD_CILINDRADA').style.display="none";this.$forceUpdate();},

		seltransmision(){var ref=this.$refs.select_IN_COD_TRANSMISION;this.TABLE.IN_COD_TRANSMISION=ref.value;this.TABLE.TRANSMISION=ref.options[ref.selectedIndex].innerHTML;document.getElementById('r_field_IN_COD_TRANSMISION').style.display="none";this.$forceUpdate();},

		seltipotraccion(){var ref=this.$refs.select_IN_COD_TIPOTRACCION;this.TABLE.IN_COD_TIPOTRACCION=ref.value;this.TABLE.TIPOTRACCION=ref.options[ref.selectedIndex].innerHTML;document.getElementById('r_field_IN_COD_TIPOTRACCION').style.display="none";this.$forceUpdate();},

		seltipocombustible(){var ref=this.$refs.select_IN_COD_TIPOCOMBUSTIBLE;this.TABLE.IN_COD_TIPOCOMBUSTIBLE=ref.value;this.TABLE.TIPOCOMBUSTIBLE=ref.options[ref.selectedIndex].innerHTML;document.getElementById('r_field_IN_COD_TIPOCOMBUSTIBLE').style.display="none";this.$forceUpdate();},

		selcolor(){var ref=this.$refs.select_IN_COD_COLOR;this.TABLE.IN_COD_COLOR=ref.value;this.TABLE.COLOR=ref.options[ref.selectedIndex].innerHTML;document.getElementById('r_field_IN_COD_COLOR').style.display="none";this.$forceUpdate();},


		//-------------------------------------------------------------------------------------------------------------------------------	
		Verificarpatente(){

			let strSql;

			strSql="SELECT IN_COD_VEHICULO codficha,"
				+"ISNULL((SELECT IN_COD_VEHICULO"
				+" FROM T_VEH_VEHICULO V"
				+" WHERE IN_COD_VEHICULO<>"+this.codvehiculo
				+" AND ST_PLACAPATENTE_VEHICULO='"+this.TABLE.ST_PLACAPATENTE_VEHICULO+"'),0) codfichaverificada"
				+" FROM T_VEH_VEHICULO V"
				+" WHERE IN_COD_VEHICULO="+this.codvehiculo


			db.getQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
				this.verificarplacapatente=result.data.data;
				//XDXD11
				console.log(this.verificarplacapatente);
				if(this.verificarplacapatente.codfichaverificada>0)
					{
					document.getElementById('placaverificada').style.display="";
					this.TABLE.ST_PLACAPATENTE_VEHICULO="";
					}
				else
					{
					document.getElementById('placaverificada').style.display="none";
					}

			}}); 

		},

	}
}

</script>
